<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">发薪查询</li>
    </ul>
    <ul class="c-list-search">
      <li style="width: 100%">
        <c_statusradiogroup
          v-model="state.params.status"
          arrName="salarypayment_status"
          @change="onLoad"
        ></c_statusradiogroup>
      </li>
      <el-input
        v-model="state.params.keywords"
        style="width: 200px"
        placeholder="名称、单号、工资表单号"
        clearable
        @clear="
          delete state.params.keywords;
          onLoad();
        "
        @paste.enter="$onKeywordsPaste($event, state.params)"
      ></el-input>
      <el-input
        v-model="state.params.keywords_employee"
        style="width: 200px"
        placeholder="员工姓名、手机号、证件号"
        clearable
        @clear="
          delete state.params.keywords_employee;
          onLoad();
        "
        @paste.enter="
          $onKeywordsPaste($event, state.params, 'keywords_employee')
        "
      ></el-input>
      <li style="width: 300px">
        <el-date-picker
          v-model="state.dates"
          type="daterange"
          range-separator="至"
          start-placeholder="到账日期"
          end-placeholder="到账日期"
          value-format="YYYY-MM-DD"
          style="width: 100%"
          @change="
            (value) => {
              if (value) state.params.pay_date = value[0] + ' - ' + value[1];
            }
          "
          @clear="
            delete state.dates;
            delete state.params.pay_date;
          "
        />
      </li>
      <el-select
        v-model="state.params.customer_id"
        placeholder="所属客户"
        style="width: 240px"
      >
        <el-option
          v-for="item in state.customerData"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
        <template #footer>
          <el-button size="small" @click="onLoadCustomer()">刷新</el-button>
        </template>
      </el-select>
      <c_withholdingagentselect
        @confirm="
          (ids) => {
            state.params.withholding_agent_id = ids;
          }
        "
      ></c_withholdingagentselect>
      <el-dropdown split-button @click="onLoad" type="primary">
        查询
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
              重置
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </ul>
    <ul class="c-list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column label="状态" width="120">
          <template #default="{ row }">
            <c_status arrName="salarypayment_status" :value="row.status" />
          </template>
        </el-table-column>
        <el-table-column
          label="名称"
          min-width="220"
          :formatter="
            (row) => $tab_GroupFormat(row.order_id || '-', row.name || '')
          "
        />
        <el-table-column
          label="所属客户/扣缴义务人"
          :formatter="
            (row) =>
              $tab_GroupFormat(
                row.customer_name || '-',
                row.withholding_agent_name || ''
              )
          "
          min-width="220"
        >
          <template #default="{ row }">
            <c_tabgroup :value2="row.customer_name || '-'">
              <template #top>
                <div
                  v-if="row.withholding_agent_id"
                  :data-type="row.withholding_agent_type == 1 ? '供' : '扣'"
                  :style="{
                    '--dynamic-color':
                      row.withholding_agent_type == 1 ? '#1e90ff' : '#ffa500',
                  }"
                  class="withholding-badge"
                  :title="row.withholding_agent_name"
                >
                  {{ row.withholding_agent_name }}
                </div>
                <text>-</text>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column
          prop="month"
          label="薪资所属期"
          :formatter="$tab_TextFormat"
          align="center"
        />
        <el-table-column
          prop="pay_date"
          label="发放日期"
          :formatter="$tab_TextFormat"
          align="center"
        />
        <el-table-column
          prop="money"
          label="发放总额"
          :formatter="$tab_MoneyFormat"
          align="center"
        />
        <el-table-column
          prop="employee_num"
          label="发放数量"
          :formatter="$tab_NumberFormat"
          align="center"
        />
        <el-table-column
          prop="payed_num"
          label="成功数"
          :formatter="$tab_NumberFormat"
          align="center"
        />
        <el-table-column
          prop="failure_num"
          label="失败数"
          :formatter="$tab_NumberFormat"
          align="center"
        />
        <el-table-column
          label="操作"
          width="160"
          align="center"
          fixed="right"
          className="tabBtn"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="Search"
              @click="
                $store.commit('openMenu', {
                  path: 'SalaryRecordDetail',
                  title: '发薪单详情',
                  refresh: true,
                  data: {
                    id: row.id,
                  },
                })
              "
            >
              查看
            </el-button>
            <el-button
              v-if="row.status == 0 && $judge_auth('679')"
              type="warning"
              link
              icon="Close"
              @click="onBack(row)"
            >
              撤回
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  data_withholdingagent_select,
  data_customer_select,
} from "@/http/data";
import { salaryrecord_list, salaryrecord_cancelpay } from "@/http/salaryrecord";
import { ElMessage, ElMessageBox } from "element-plus";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
  };
}
export default {
  setup() {
    const state = reactive(new InitFormData());
    onMounted(() => {
      onLoadWithholdingAgent();
      onLoadCustomer();
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      salaryrecord_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //加载扣缴义务人
    const onLoadWithholdingAgent = () => {
      data_withholdingagent_select().then((res) => {
        if (res.status == 200)
          state.withholding_agent_data = res.data.data?.list;
      });
    };

    //获取客户
    const onLoadCustomer = () => {
      data_customer_select().then((res) => {
        if (res.status == 200) state.customerData = res.data.data?.list;
      });
    };

    const onDateChange = (value) => {
      if (value) state.params.pay_date = value[0] + " - " + value[1];
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    const onBack = (row) => {
      ElMessageBox.confirm(
        `您确定<strong style='color:#ffa500'>撤回</strong>发薪单<strong style='color:#1e90ff'>${row.order_id}</strong>吗？`,
        "撤回确认",
        {
          confirmButtonText: "确定撤回",
          cancelButtonText: "取消",
          confirmButtonClass: "el-button--warning",
          dangerouslyUseHTMLString: true,
          type: "warning",
        }
      ).then(() => {
        salaryrecord_cancelpay(row.id).then((res) => {
          if (res.status == 200) {
            ElMessage({
              type: "success",
              message: res.data.msg,
            });
            onLoad();
          }
        });
      });
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      onLoadCustomer,
      onDateChange,
      onBack,
    };
  },
};
</script>
<style lang="less">
.bank-received-index-tab-pop {
  .el-descriptions__header {
    margin-bottom: 0 !important;
  }
}
</style>
